<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import type { PublicLinkPageResult } from '@/modules/link-page';

defineProps<{ result: PublicLinkPageResult; siteOrigin: string }>();
const { t } = useI18n();
</script>

<template>
  <main class="flex min-h-screen flex-col items-center gap-4 bg-noir-950 px-5 py-10 text-center text-cream-100">
    <template v-if="result.status === 'found'">
      <img v-if="result.page.photo_url" :src="result.page.photo_url" :alt="t('linkPage.publicPhoto', { name: result.page.name ?? '' })" class="h-24 w-24 rounded-full border-2 border-gold-400 object-cover" />
      <h1 v-if="result.page.name" class="font-display text-3xl">{{ result.page.name }}</h1>
      <p v-if="result.page.tagline" class="text-sm text-noir-300">{{ result.page.tagline }}</p>
      <div v-if="result.page.links.length" class="mt-4 grid w-full max-w-md gap-3">
        <a v-for="(link, index) in result.page.links" :key="index" :href="link.url" class="rounded-lg border border-noir-600 bg-noir-900 px-4 py-3 font-semibold">{{ link.label }}</a>
      </div>
      <p v-else class="mt-4 w-full max-w-md rounded border border-dashed border-noir-700 p-4 text-noir-300">{{ t('linkPage.empty') }}</p>
    </template>
    <template v-else>
      <p class="mt-12 font-display text-6xl text-gold-400">404</p>
      <h1 class="font-display text-3xl">{{ t('linkPage.unavailable') }}</h1>
      <p class="text-noir-300">{{ t('linkPage.unavailableHint') }}</p>
      <div class="mt-4 grid w-full max-w-md gap-3">
        <a v-if="result.profileSlug !== null" :href="`${siteOrigin}/@${result.profileSlug}`" class="rounded bg-gold-400 px-4 py-3 text-noir-950">{{ t('linkPage.profile') }}</a>
        <a :href="siteOrigin" class="rounded border border-noir-600 px-4 py-3">{{ t('linkPage.goSite') }}</a>
      </div>
    </template>
    <footer class="mt-auto pt-10"><a :href="siteOrigin" class="font-display text-gold-400">{{ t('linkPage.brand') }}</a></footer>
  </main>
</template>
